import { Tabs, Tab } from "@mui/material";
import MyReviewItems from "components/my-review/my-review-items";
import ReviewManagement from "components/my-review/review-management";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAction, loadAlert, loadFavAlert } from "redux/reducers/top";
import { useHistory } from "react-router-dom";

export default function MyReview() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [tabVal, setTabVal] = useState(0);

  const { init, alertOpen, favAlertOpen } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "My 리뷰", menu: true }));
  }, [init]);

  return (
    <>
      <Tabs
        value={tabVal}
        onChange={(e, val) => {
          setTabVal(val);
        }}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label="상품리뷰" />
        <Tab label="리뷰관리" />
      </Tabs>
      {tabVal == 0 ? <MyReviewItems /> : <ReviewManagement />}
    </>
  );
}
